<template>
  <section name="home" :class="{'stats-open': selectedTrainingStats!=-1 }">
    <div class="home-section" :class="{'home-table-view': selectedView ==0}">
      <HeaderButtons
        :options="{
          showCreateBtn: showCreateBtn(), 
          loadingItem: addingTraining, 
          loadingGroupItem: addingTrainingGroup, 
          createItemBtnText: 'trainings.create_new',
          createGroupBtnText: 'training_groups.create_new',
          trainingGroup: trainingGroup,
          // showGroupCreateBtn: false,
          showGroupCreateBtn: false,
          // createItemAction: () => addNewTraining($store.state.currentGroupOpen),
          createItemAction: (type) => addNewTrainingV2($store.state.currentGroupOpen, type),
          createGroupItemAction: () => addNewTrainingGroup($store.state.currentGroupOpen),
          selectedTrainingStats: selectedTrainingStats,
          showBackBtn:true,
          selectedView: selectedView,
          type: 'edit',
          mode: 'edit'
        }"
        :addingTraining="addingTraining"
        @addNewTraining="addNewTraining"
        @selectView="selectedView=$event"
        @selectMode="selectedMode=$event"
        @goBack="goBack"
      />
      <TrainingTableView 
        v-show="selectedView==0"
        v-if="trainingGroup && selectedView==0"
        :trainingGroup="trainingGroup"
        :selectedMode="selectedMode"
      />
      <!-- <span v-if="selectedView==1" class="folder-title" :class="{'not-editing':!editingTitle}" @click="startTitleEdit" v-click-outside-2="finishTitleEdit">
        <input ref="titleInput" v-if="editingTitle" type="text" v-model="trainingGroup.name" maxlength="255">
        <span v-else>{{trainingGroup.name}}</span>
        <svg v-if="hasPermission('trainings.edit_in_groups')" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.715908 15.984L4.43787 15.1501H4.46906C4.64378 15.1499 4.81675 15.1153 4.97804 15.0481C5.13933 14.9809 5.28577 14.8826 5.40898 14.7588L15.6028 4.56909C15.8547 4.31619 15.9961 3.97385 15.9961 3.61699C15.9961 3.26013 15.8547 2.9178 15.6028 2.66489L13.3352 0.392144C13.0822 0.140372 12.7397 -0.000976562 12.3827 -0.000976562C12.0257 -0.000976562 11.6832 0.140372 11.4302 0.392144L1.23033 10.5879C1.10538 10.7132 1.00727 10.8625 0.941957 11.027C0.876647 11.1914 0.845511 11.3673 0.850449 11.5442L0.0124846 15.2814C-0.0046463 15.3652 -0.0046463 15.4516 0.0124846 15.5354C0.0289097 15.6116 0.0603352 15.6838 0.104934 15.7477C0.149531 15.8116 0.20641 15.866 0.272253 15.9077C0.367145 15.9678 0.476979 16 0.589283 16.0008C0.63256 16.0016 0.675761 15.9968 0.717772 15.9864M12.021 0.983134C12.1169 0.887654 12.2468 0.834051 12.3822 0.834051C12.5176 0.834051 12.6475 0.887654 12.7435 0.983134L15.0116 3.25542C15.0597 3.30212 15.0979 3.35805 15.1239 3.41986C15.1499 3.48167 15.1632 3.54808 15.1629 3.61513C15.1628 3.68254 15.1494 3.74926 15.1234 3.81147C15.0974 3.87368 15.0594 3.93015 15.0116 3.97764L14.0288 4.95998L11.0354 1.96781L12.021 0.983134ZM2.09529 10.9048L10.4442 2.5574L13.4376 5.54958L5.08869 13.897L2.09529 10.9048ZM1.28619 13.4344L1.6805 11.6726L4.32847 14.3195L2.43467 14.742L1.28619 13.4344Z" fill="white"/>
        </svg>
      </span> -->
      <BreadcrumbNav
        v-if="trainingGroup"
        :path="trainingGroup.path"
        @goTo="goToGroup($event)"
        @updateTitle="updateGroupTitle($event)"
      />
      <div
        :class="{
          'container wide--container main--container': true,
          'side--open': $store.getters.isSideOpen(),
          loaded: loaded,
        }"
        v-if="selectedView==1"
      >
        <div
          class="card-container"
          :class="{ flexStart: trainingGroup.trainings.length < 5 }"
          v-if="trainingGroup != '' && loaded"
        >
        
          <draggable
            class="inside-container"
            v-model="trainingGroup.trainings"
            animation="200"
            :options="{ disabled:  dragDisabled}"
            @end="onTrainingListChange(trainingGroup)"
          >
            <transition-group type="transition" class="centering" v-if="trainingGroup != undefined">
              <TrainingGroupFolder
                v-for="folder in trainingGroup.training_groups"
                :key="'index-'+folder.id"
                :showSettings="true"
                :folder="folder"
                :options="{
                  minWidth: 33,
                }"
                @openGroup="openGroup"
                @deleteGroup="deleteGroup"
                @toggleDrag="toggleDrag(folder, $event)"
                @openGroupSide="openTrainingGroupSide"
                @uploadFolderImg="uploadFolderImg"
              />
              <div
                v-for="(training, trainingIndex) in trainingGroup.trainings"
                :key="`training-${trainingGroup.id}-${trainingIndex}`"
                :class="[
                  'card',
                  $store.getters.hasPermission('training.*')
                    ? 'with--actions'
                    : '',
                ]"
              >
              <div class="tag-container">
                <span
                  v-if="$store.state.system_settings.isShop && !training.data.published"
                >
                  {{toLocal('home_edit.not_published')}}
                </span>
                 <span
                  class="attest-tag"
                  v-if="training.data && training.data.trainingType && training.data.trainingType == 'attest'"
                >
                  {{toLocal("training.attesting")}}
                  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.7769 7.3613C19.6301 7.01525 19.6092 6.48046 19.5987 5.96663C19.5672 5.02288 19.5253 3.96377 18.7807 3.21926C18.0362 2.47474 16.9771 2.44328 16.0334 2.40133C15.5091 2.38036 14.9743 2.35939 14.6387 2.22307C14.3241 2.09724 13.9466 1.74071 13.5796 1.39466C12.877 0.734032 12.0906 0 11 0C9.90944 0 9.12297 0.744519 8.4204 1.39466C8.05338 1.74071 7.67588 2.08675 7.3613 2.22307C7.01525 2.35939 6.48046 2.38036 5.96663 2.40133C5.02288 2.43279 3.96377 2.47474 3.21926 3.21926C2.47474 3.96377 2.44328 5.02288 2.40133 5.96663C2.38036 6.49094 2.35939 7.02574 2.22307 7.3613C2.09724 7.67588 1.74071 8.05338 1.39466 8.4204C0.734032 9.12297 0 9.90944 0 11C0 12.0906 0.744519 12.877 1.39466 13.5796C1.74071 13.9466 2.08675 14.3241 2.22307 14.6387C2.35939 14.9847 2.38036 15.5195 2.40133 16.0334C2.43279 16.9771 2.47474 18.0362 3.21926 18.7807C3.96377 19.5253 5.02288 19.5567 5.96663 19.5987C6.49094 19.6196 7.02574 19.6406 7.3613 19.7769C7.67588 19.9028 8.05338 20.2593 8.4204 20.6053C9.12297 21.266 9.90944 22 11 22C12.0906 22 12.877 21.2555 13.5796 20.6053C13.9466 20.2593 14.3241 19.9133 14.6387 19.7769C14.9847 19.6301 15.5195 19.6196 16.0334 19.5987C16.9771 19.5672 18.0362 19.5253 18.7807 18.7807C19.5253 18.0362 19.5567 16.9771 19.5987 16.0334C19.6196 15.5091 19.6406 14.9743 19.7769 14.6387C19.9028 14.3241 20.2593 13.9466 20.6053 13.5796C21.266 12.877 22 12.0906 22 11C22 9.90944 21.2555 9.12297 20.6053 8.4204C20.2593 8.05338 19.9028 7.67588 19.7769 7.3613ZM19.368 12.4156C18.9275 12.8875 18.4662 13.3804 18.2145 13.9781C17.9523 14.5968 17.9314 15.2888 17.8999 15.96C17.8789 16.6206 17.8475 17.3022 17.5748 17.5748C17.3022 17.8475 16.6206 17.8684 15.96 17.8999C15.2888 17.9209 14.5968 17.9523 13.9781 18.2145C13.3804 18.4662 12.8875 18.9275 12.4156 19.368C11.9228 19.8294 11.409 20.3117 10.9895 20.3117C10.5701 20.3117 10.0562 19.8294 9.56339 19.368C9.09152 18.9275 8.59867 18.4662 8.00095 18.2145C7.38227 17.9523 6.69018 17.9314 6.01907 17.8999C5.35844 17.8789 4.67684 17.8475 4.40419 17.5748C4.13155 17.3022 4.11058 16.6206 4.07912 15.96C4.05815 15.2888 4.02669 14.5968 3.76454 13.9781C3.51287 13.3804 3.05148 12.8875 2.61106 12.4156C2.14967 11.9228 1.6673 11.409 1.6673 10.9895C1.6673 10.5701 2.14967 10.0562 2.61106 9.56339C3.05148 9.09152 3.51287 8.59867 3.76454 8.00095C4.01621 7.38227 4.04766 6.69018 4.06864 6.01907C4.08961 5.35844 4.12107 4.67684 4.39371 4.40419C4.66635 4.13155 5.34795 4.11058 6.00858 4.07912C6.67969 4.05815 7.37178 4.02669 7.99047 3.76454C8.58818 3.51287 9.08103 3.05148 9.55291 2.61106C10.0458 2.14967 10.5596 1.6673 10.979 1.6673C11.3985 1.6673 11.9018 2.14967 12.4051 2.61106C12.877 3.05148 13.3699 3.51287 13.9676 3.76454C14.5863 4.02669 15.2784 4.04766 15.9495 4.07912C16.6101 4.1001 17.2917 4.13155 17.5643 4.40419C17.837 4.67684 17.858 5.35844 17.8789 6.01907C17.9104 6.69018 17.9314 7.38227 18.1935 8.00095C18.4452 8.59867 18.9066 9.09152 19.347 9.56339C19.8084 10.0562 20.2908 10.5701 20.2908 10.9895C20.2908 11.409 19.8294 11.9228 19.368 12.4156Z" fill="white"/>
                    <path d="M11 4.50879C7.4242 4.50879 4.51953 7.42395 4.51953 10.9892C4.51953 14.5545 7.43469 17.4697 11 17.4697C14.5653 17.4697 17.4804 14.5545 17.4804 10.9892C17.4804 7.42395 14.5863 4.50879 11 4.50879ZM11 15.7919C8.35747 15.7919 6.21829 13.6422 6.20781 10.9997C6.20781 8.35722 8.35747 6.20755 11 6.20755C13.6425 6.20755 15.7922 8.35722 15.7922 10.9997C15.7922 13.6422 13.6425 15.7814 11 15.7919Z" fill="white"/>
                    <path d="M12.8356 8.36805L9.67928 11.5139L8.82991 10.654C8.50483 10.3395 7.94907 10.3395 7.63448 10.654C7.4667 10.8113 7.38281 11.0315 7.38281 11.2517C7.38281 11.472 7.4667 11.6817 7.62399 11.839L9.08157 13.2966C9.23887 13.4538 9.4381 13.5482 9.6688 13.5482C9.8995 13.5482 10.1092 13.4538 10.277 13.2966L14.0206 9.55299C14.1779 9.39569 14.2722 9.17549 14.2722 8.95528C14.2722 8.73507 14.1779 8.51486 14.0206 8.35756C13.706 8.04298 13.1397 8.03249 12.8251 8.35756L12.8356 8.36805Z" fill="white"/>
                  </svg>
                </span>
                <span 
                  class="physical-tag"
                  v-if="training.data && training.data.type == 'new_player'"
                >
                  {{toLocal('home_edit.physical_training')}}
                </span>
                <span 
                  class="physical-tag"
                  v-if="training.data && training.data.trainingType && training.data.trainingType == 'scorm'"
                >
                  {{toLocal('trainingEdit.interactive_scorm')}}
                </span>
                <span 
                  class="physical-tag"
                  v-if="training.data && training.data.trainingType && training.data.trainingType == 'doc'"
                >
                  {{toLocal('trainingEdit.document_folder')}}
                </span>
                <span 
                  class="physical-tag"
                  v-if="training.data && training.data.trainingType && training.data.trainingType == 'singleDoc'"
                >
                  {{toLocal('training_edit.doc')}}
                </span>
                <span
                  v-if="$store.state.system_settings.isShop && training.data.paid"
                  class="selling-tag"
                >
                  {{toLocal('home_edit.selling')}}
                </span>
            </div>
                <div class="over-cover" v-if="training.enabled == 0">
                  <span class="disabled-tag">{{
                    toLocal("generic.disabled")
                  }}</span>
                  <!-- <TrainingEyeSvg /> -->
                </div>
                <div
                  class="cover"
                  :style="[
                    training.data.cover != ''
                      ? {
                          'background-image': `url('${getFileUrl(
                            training.data.cover
                          )}')`,
                        }
                      : {},
                  ]"
                  @click="training.data.trainingType =='attest' ? openTraining(training.id, training) :  editTraining(training.id, null, training.created_by)"
                >
                  <div class="play-button" v-if="training.enabled != 0">
                    <!-- <TrainingEyeSvg /> -->
                  </div>
                  <div class="title">
                    <span class="card-title">{{ training.data.title }}</span>
                    <div class="languages" :class="{parent: training.parent_id == null}" v-if="training.data.selectedEnTraining || training.data.selectedRuTraining || training.parent_id">
                      <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.0013 0.914062C4.1937 0.914063 3.40423 1.15355 2.73272 1.60223C2.06122 2.05091 1.53785 2.68864 1.2288 3.43477C0.919738 4.1809 0.838874 5.00192 0.996431 5.79401C1.15399 6.5861 1.54289 7.31368 2.11395 7.88475C2.68502 8.45581 3.4126 8.84471 4.20468 9.00227C4.99677 9.15982 5.81779 9.07896 6.56393 8.7699C7.31006 8.46084 7.94779 7.93747 8.39647 7.26597C8.84515 6.59447 9.08463 5.805 9.08463 4.99739C9.08339 3.91481 8.65278 2.87692 7.88728 2.11142C7.12177 1.34592 6.08389 0.915309 5.0013 0.914062ZM8.45643 4.99739C8.4567 5.31604 8.4127 5.63317 8.32568 5.9397H6.81367C6.91 5.31519 6.91 4.6796 6.81367 4.05509H8.32568C8.4127 4.36162 8.4567 4.67875 8.45643 4.99739ZM3.98047 6.56791H6.02214C5.821 7.22697 5.47182 7.83131 5.0013 8.33473C4.53096 7.83118 4.18181 7.22688 3.98047 6.56791ZM3.82734 5.9397C3.71951 5.31612 3.71951 4.67866 3.82734 4.05509H6.1784C6.28624 4.67866 6.28624 5.31612 6.1784 5.9397H3.82734ZM1.54618 4.99739C1.5459 4.67875 1.5899 4.36162 1.67692 4.05509H3.18893C3.09261 4.6796 3.09261 5.31519 3.18893 5.9397H1.67692C1.5899 5.63317 1.5459 5.31604 1.54618 4.99739ZM6.02214 3.42688H3.98047C4.18161 2.76782 4.53078 2.16348 5.0013 1.66006C5.47164 2.16361 5.82079 2.76791 6.02214 3.42688ZM8.07676 3.42688H6.67822C6.50195 2.78019 6.20487 2.1727 5.80266 1.6365C6.28862 1.75324 6.74359 1.97368 7.13638 2.28271C7.52917 2.59174 7.8505 2.98205 8.07833 3.42688H8.07676ZM4.19995 1.6365C3.79774 2.1727 3.50066 2.78019 3.32439 3.42688H1.92428C2.15211 2.98205 2.47343 2.59174 2.86623 2.28271C3.25902 1.97368 3.71399 1.75324 4.19995 1.6365ZM1.92428 6.56791H3.32439C3.50066 7.2146 3.79774 7.82209 4.19995 8.35829C3.71399 8.24155 3.25902 8.02111 2.86623 7.71208C2.47343 7.40305 2.15211 7.01274 1.92428 6.56791ZM5.80266 8.35829C6.20487 7.82209 6.50195 7.2146 6.67822 6.56791H8.07833C7.8505 7.01274 7.52917 7.40305 7.13638 7.71208C6.74359 8.02111 6.28862 8.24155 5.80266 8.35829Z" fill="#4A4A4A"/>
                      </svg>
                    </div>

                    <div class="slider">
                      <span v-if="training.data.time != 0" class="slider--time">
                        {{ getTrainingTime(training.data.time) }}
                      </span>
                      <div class="slider--bar">
                        <div class="slider--fill" style="width: 0%" />
                        <div class="slider--blob" />
                      </div>
                    </div>
                  </div>
                </div>
                      <div
                  class="option-dots"
                  v-if="training.id != -1 && showMenu(training, 'dots')"
                  @click.stop="
                    activeOptionMenu == training.id
                      ? closeMenus()
                      : activeOptionMenu == -50
                      ? (activeOptionMenu = training.id)
                      : (activeOptionMenu = -50)
                  "
                >
                  <OptionDotsSvg class="themable"/>
                </div>
                <div
                  class="option-menu"
                  v-click-outside-2="closeMenus"
                  v-if="showMenu(training)"
                >
                  <div 
                  v-if="showMenuItem(training,'view')" 
                  class="color option-block" 
                  v-tooltip="{content: toLocal('emails.training_inv_btn'), classes: 'tooltip-container icon-tooltip'}"
                  @click.stop="training.data.trainingType !='attest' ? openTraining(training.id, training) :  editTraining(training.id, null, training.created_by)"
                  
                  >
                    <HomeEditEditTrainingSvg v-if="training.data.trainingType =='attest'" class="stroke" />
                    <svg v-else width="30" height="16" viewBox="0 0 30 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M28 8.00205C26.448 10.1736 24.4303 11.9373 22.1079 13.1523C19.7855 14.3673 17.2226 15 14.6238 15C12.0251 15 9.46252 14.3673 7.14014 13.1523C4.81777 11.9373 2.80006 10.1736 1.24805 8.00205C2.79935 5.82939 4.8165 4.06471 7.13897 2.84896C9.46143 1.6332 12.0247 1 14.6238 1C17.223 1 19.7862 1.6332 22.1087 2.84896C24.4312 4.06471 26.4487 5.82939 28 8.00205Z" stroke="#707070" stroke-width="2" stroke-miterlimit="10"/>
                      <path d="M14.624 12.5807C17.0521 12.5807 19.0205 10.5301 19.0205 8.00039C19.0205 5.47074 17.0521 3.42004 14.624 3.42004C12.1959 3.42004 10.2275 5.47074 10.2275 8.00039C10.2275 10.5301 12.1959 12.5807 14.624 12.5807Z" stroke="#707070" stroke-width="2" stroke-miterlimit="10"/>
                    </svg>
                  </div>
                  <div class="pencil option-block" v-tooltip="{content: toLocal('trainings.added_users'), classes: 'tooltip-container icon-tooltip'}" @click.stop="openGroupSide(training)" 
                  v-if="showMenuItem(training,'users')">
                    <HomeEditOpenGroupSvg class="stroke" />
                  </div>
                  <div class="trash option-block" v-tooltip="{content: toLocal('training.training_stats'), classes: 'tooltip-container icon-tooltip'}" @click.stop="trainingStats(training, training.id, training.rented)" 
                  v-if="showMenuItem(training,'stats')">
                    <HomeEditStatsSvg class="stroke fill-gray" />
                  </div>
                  <div class="option-block" v-tooltip="{content: toLocal('training.delete_training_label'), classes: 'tooltip-container icon-tooltip'}" @click.stop="deleteTraining(training.id)" v-if="showMenuItem(training,'delete')">
                    <HomeEditDeleteTrainingSvg class="stroke smaller" />
                  </div>
                  <div class="option-block" v-tooltip="{content: toLocal('training.copy_training'), classes: 'tooltip-container icon-tooltip'}" @click.stop="copyTraining(training.id)" v-if="showMenuItem(training,'copy')">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M19.1667 0H5.83333C5.61232 0 5.40036 0.0877975 5.24408 0.244078C5.0878 0.400358 5 0.61232 5 0.833333V5H0.833333C0.61232 5 0.400358 5.0878 0.244078 5.24408C0.0877975 5.40036 0 5.61232 0 5.83333V19.1667C0 19.3877 0.0877975 19.5996 0.244078 19.7559C0.400358 19.9122 0.61232 20 0.833333 20H14.1667C14.3877 20 14.5996 19.9122 14.7559 19.7559C14.9122 19.5996 15 19.3877 15 19.1667V15H19.1667C19.3877 15 19.5996 14.9122 19.7559 14.7559C19.9122 14.5996 20 14.3877 20 14.1667V0.833333C20 0.61232 19.9122 0.400358 19.7559 0.244078C19.5996 0.0877975 19.3877 0 19.1667 0ZM13.3333 18.3333H1.66667V6.66667H13.3333V18.3333ZM18.3333 13.3333H15V5.83333C15 5.61232 14.9122 5.40036 14.7559 5.24408C14.5996 5.0878 14.3877 5 14.1667 5H6.66667V1.66667H18.3333V13.3333Z" fill="#7D7D7D"/>
                    </svg>
                  </div>
                  <div class="option-block" v-tooltip="{content: toLocal('training.move_training'), classes: 'tooltip-container icon-tooltip'}" @click.stop="moveTraining(training.id)" v-if="showMenuItem(training,'move')">
                    <svg width="28" height="26" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M22.988 6.5H21.9765C19.7172 6.5 19.7208 3.25 18.1248 3.25H8.51025C6.71125 3.25 5.25 4.60688 5.25 6.279V9.75H7V6.279C7 5.5055 7.679 4.875 8.51025 4.875H17.7922C17.9007 5.031 18.039 5.265 18.1387 5.43887C18.725 6.44312 19.7067 8.125 21.9765 8.125H22.988C23.765 8.125 24.5 8.91475 24.5 9.75V19.7226C24.5 20.4945 23.821 21.125 22.988 21.125H8.51025C7.679 21.125 7 20.4945 7 19.7226V17.875H5.25V19.7226C5.25 21.3948 6.71125 22.75 8.51025 22.75H22.9863C24.7888 22.75 26.25 21.3948 26.25 19.7226V9.75C26.25 8.07787 24.7887 6.5 22.988 6.5Z" fill="#707070"/>
                      <path d="M13.5993 17.6172L17.2376 14.3201C17.2411 14.3168 17.2428 14.3119 17.2463 14.3071C17.3233 14.2356 17.3881 14.0649 17.4318 13.9707C17.4686 13.8829 17.4826 13.9544 17.4896 13.8667C17.4896 13.8472 17.5001 13.8309 17.5001 13.8131C17.5001 13.8001 17.4931 13.7903 17.4931 13.7789C17.4878 13.6814 17.4686 13.6327 17.4318 13.5417C17.3951 13.4588 17.3356 13.3889 17.2743 13.3223C17.2603 13.3061 17.2533 13.2833 17.2376 13.2687L13.5993 9.89357C13.2493 9.56695 12.6806 9.71645 12.3306 10.0431C11.9788 10.3681 11.9788 10.8962 12.3306 11.2228L14.4323 13.0249L2.68459 13.0266C2.17184 13.0266 1.75534 13.3516 1.75709 13.8114C1.75534 14.2713 2.17184 14.5654 2.68634 14.5654H14.4341L12.3323 16.5853C11.9806 16.9119 11.9806 17.4384 12.3323 17.7667C12.5073 17.9292 12.7348 17.8626 12.9658 17.8626C13.1968 17.8626 13.4261 17.7781 13.5993 17.6172Z" fill="#707070"/>
                    </svg>

                  </div>
                </div>
         
                <div
                  v-if="!$store.getters.hasPermission('training.*')"
                  class="description"
                >
                  {{ training.data.description }}
                </div>
              </div>
            </transition-group>
          </draggable>
        </div>
      </div>
    </div>
    <GlobalModal
      v-if="deletingTraining"
      :modalInfo="{
        type: 'confirmation',
        text: 'training_edit.delete_confirm',
        undertext: '',
        confirmBtnText: 'delete_modal.yes_delete',
        class:'delete'
      }"
      @onConfirm="deleteTrainingRequest"
      @onClose="deletingTraining = false"
    />
    <AssignModal
      v-if="selectedTraining"
      v-scroll-lock="selectedTraining"
      type="training"
      :item="selectedTraining"
      @modalClose="selectedTraining=null"
    />
    <TrainingStats 
      v-if="selectedTrainingStats!=-1" 
      v-scroll-lock="selectedTrainingStats!=-1" 
      :selectedTraining="selectedTrainingStats"
      :item="selectedTrainingItem"
      @goBack="closeStats"
    />
    <AssignModal
      v-if="selectedFolder && !galleryOpen"
      v-scroll-lock="selectedFolder"
      type="trainingGroup"
      :item="selectedFolder"
      @modalClose="selectedFolder=null"
    />
    <GallerySide
      v-if="galleryOpen"
      @returnPickedGif="uploadGif"
      :selectedItemData="selectedFolder"
      :hasUpload="true"
      @closeGallery="galleryOpen = false; selectedFolder = null;"
      @changeGroupImg="uploadGroupImg"
      @removeGroupImg="removeGroupImg"
    />
    <GlobalModal
      :modalInfo="{
        text: 'training.group_delete_confirm',
        confirmBtnText: 'delete_modal.yes_delete',
        type: 'confirmation',
      }"
      @onConfirm="confirmedGroupDelete"
      @onClose="closeDeleteModal"
      v-if="deleteModalOpened"
    />
    <GlobalModal
      v-if="multiChoiceOpened"
      :modalInfo="multiChoiceInfo"
      @onClose="multiChoiceOpened=false"
      @onChoiceOne="choiceOne"
      @onChoiceTwo="choiceTwo"
      @onConfirm="deleteGroupWithTrainings"
    />
    <TrainingMoveModal v-if="copyTrainingModalOpen" :item_id="copyTrainingID" @close="copyTrainingModalOpen = false"/>
    <TrainingMoveModal v-if="moveTrainingModalOpen" type="move" :item_group_id="moveTrainingID == 'all' ? deletingStatus : $store.state.currentGroupOpen" :item_id="moveTrainingID" @close="moveTrainingModalOpen = false" @move="removeMovedTraining"/>
    <HomeTrainingOverlay v-if="overlay.open" :data="overlay.data" @close="overlay.open=false"/>
  </section>
</template>

<script>
import axios from "axios";
import draggable from "vuedraggable";
import VueScrollTo from "vue-scrollto";
import TrainingGroupsSide from "../components/layout/trainings/TrainingGroupsSide";
import TrainingTableView from "../components/layout/trainings/TrainingTableView";
import TrainingStats from "@/views/TrainingStats";
import HomeTrainingOverlay from "@/components/layout/trainings/overlay/HomeTrainingOverlay.vue";
import GallerySide from "@/components/layout/modals/GallerySide.vue";
import BreadcrumbNav from "@/components/layout/trainingGroups/BreadcrumbNav.vue";

import _ from "lodash";
import { ObserveVisibility } from "vue-observe-visibility";
import GlobalModal from "@/components/layout/modals/GlobalModal.vue";
import AssignModal from "@/components/layout/modals/AssignModal.vue";
import TrainingSearch from "@/components/layout/TrainingSearch.vue";
import HeaderButtons from "@/components/layout/HeaderButtons.vue";
import TrainingGroupFolder from "@/components/layout/trainingGroups/TrainingGroupFolder.vue";
import TrainingMoveModal from "@/components/layout/modals/TrainingMoveModal.vue";


//SVG
import HomeEditSearchSvg from "@/assets/images/icons/homeEdit/home-edit-search.svg?inline";
import HomeEditSearchCancelSvg from "@/assets/images/icons/homeEdit/home-edit-search-cancel.svg?inline";
import HomeEditAddSvg from "@/assets/images/icons/homeEdit/home-edit-add.svg?inline";
import HomeEditDeleteSvg from "@/assets/images/icons/homeEdit/home-delete-widthless.svg?inline";
import HomeEditArrowDownSvg from "@/assets/images/icons/homeEdit/home-edit-arrow-down.svg?inline";
import HomeEditArrowUpSvg from "@/assets/images/icons/homeEdit/home-edit-arrow-up.svg?inline";
import HomeEditPlaySvg from "@/assets/images/icons/homeEdit/home-edit-play.svg?inline";
import HomeEditEditTrainingSvg from "@/assets/images/icons/homeEdit/home-edit-widthless.svg?inline";
import HomeEditOpenGroupSvg from "@/assets/images/icons/homeEdit/home-edit-group-widthless.svg?inline";
import HomeEditStatsSvg from "@/assets/images/icons/homeEdit/home-edit-stats-widthless.svg?inline";
import HomeEditDeleteTrainingSvg from "@/assets/images/icons/homeEdit/home-delete-widthless.svg?inline";
import PlusNarrowSvg from "@/assets/images/icons/plus-narrow-white.svg?inline";
import GroupSearchSvg from "@/assets/images/icons/group-search-black.svg?inline";
import LoadingBubbleSvg from "@/assets/images/icons/loading-bubble.svg?inline";
import ArrowLeftSvg from "@/assets/images/icons/homeEdit/arrow-go-back-16-8.svg?inline";
import TrainingDisabledSvg from "@/assets/images/icons/training-edit/training_disabled.svg?inline";
import TrainingEyeSvg from "@/assets/images/icons/training-edit/training_eye.svg?inline";
import OptionDotsSvg from "@/assets/images/icons/option-dots-edit.svg?inline";
import M from "minimatch";

export default {
  name: "HomeEdit",
  components: {
    OptionDotsSvg,
    draggable,
    TrainingGroupsSide,
    TrainingStats,
    GlobalModal,
    AssignModal,
    TrainingSearch,
    HeaderButtons,
    TrainingTableView,
    HomeTrainingOverlay,
    TrainingGroupFolder,
    GallerySide,
    TrainingMoveModal,
    BreadcrumbNav,
    //SVG COMPONENTS
    HomeEditSearchSvg,
    HomeEditSearchCancelSvg,
    HomeEditAddSvg,
    HomeEditDeleteSvg,
    HomeEditArrowDownSvg,
    HomeEditArrowUpSvg,
    HomeEditPlaySvg,
    HomeEditEditTrainingSvg,
    HomeEditOpenGroupSvg,
    HomeEditStatsSvg,
    HomeEditDeleteTrainingSvg,
    PlusNarrowSvg,
    GroupSearchSvg,
    LoadingBubbleSvg,
    ArrowLeftSvg,
    TrainingDisabledSvg,
    TrainingEyeSvg,
  },
 
  directives: {
    "click-outside-editing-title": {
      bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          if (!(el == event.target || el.contains(event.target))) {
            let index = vnode.data.ref.split("-")[1];
            vnode.context.setGroupTitle(index, vnode.elm.value);
          }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
      },
      unbind: function (el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
      },
    },
    ObserveVisibility,
  },

  data: function () {
    return {
      addingTraining: false,
      addingNewGroup: false,
      trainingGroup: "",
      trainings: [],
      loaded: false,
      selectedTraining: null,
      isSearching: false,
      searchInputValue: "",
      isHeaderInView: true,
      searchTerm: "",
      multiChoiceInfo: {
        type: "multiChoice",
        text: "modal.group_with_trainings",
        undertext: "modal.choose_what_to_do",
        multiChoiceYes: "modal.transfer_to_another",
        multiChoiceNo: "modal.delete_forever",
      },
      dragItems: {},
      deleteModalOpened: false,
      deletingStatus: "",
      multiChoiceOpened: false,
      selectedTrainingStats: -1,
      selectedTrainingItem: null,
      activeOptionMenu: -50,
      deletingTraining: false,
      deletingTrainingID: -1,
      assignModalOpen:false,
      editingTitle:false,
      selectedView: 1,
      tableTrainings: [],
      loadedTableTrainings: false,
      selectedMode: 1,
      addingTrainingGroup: false,
      trainingGroups: [],
      galleryOpen: false,
      dragDisabled: false,
      overlay: {
        open: false,
        data: {
          
        }
      },
      selectedFolder: null,
      colorPalettes: [
        [
        "rgba(230, 69, 69, 1)",
        "rgba(229, 115, 0, 1)",
        "rgba(191, 143, 0, 1)",
        "rgba(100, 153, 46, 1)",
        "rgba(46, 153, 46, 1)",
        "rgba(46, 153, 100, 1)",
        "rgba(46, 153, 153, 1)",
        "rgba(69, 150, 229, 1)",
        "rgba(69, 69, 229, 1)",
        "rgba(150, 69, 230, 1)",
        "rgba(153, 46, 153, 1)",
        "rgba(229, 69, 150, 1)",
        ],
        [
        "rgba(229, 115, 115, 1)",
        "rgba(229, 166, 103, 1)",
        "rgba(229, 229, 103, 1)",
        "rgba(184, 229, 138, 1)",
        "rgba(138, 229, 138, 1)",
        "rgba(115, 229, 172, 1)",
        "rgba(115, 229, 229, 1)",
        "rgba(115, 172, 229, 1)",
        "rgba(138, 138, 229, 1)",
        "rgba(184, 138, 230, 1)",
        "rgba(229, 138, 229, 1)",
        "rgba(229, 138, 184, 1)",
        ],
        [
        "rgba(229, 184, 184, 1)",
        "rgba(229, 207, 184, 1)",
        "rgba(229, 229, 184, 1)",
        "rgba(207, 229, 184, 1)",
        "rgba(184, 229, 184, 1)",
        "rgba(184, 229, 207, 1)",
        "rgba(184, 229, 229, 1)",
        "rgba(184, 207, 229, 1)",
        "rgba(184, 184, 229, 1)",
        "rgba(207, 184, 229, 1)",
        "rgba(229, 184, 229, 1)",
        "rgba(229, 184, 207, 1)",
        ],
    ],
    copyTrainingModalOpen: false,
    copyTrainingID: -1,
    moveTrainingModalOpen: false,
    moveTrainingID: -1,
    
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    // if(this.$route.query.editTitle && this.$route.query.editTitle == 1){
    //   this.startTitleEdit()
    // }
    this.loadEditPage();
  },
  beforeDestroy() {
    this.loaded = false;
    this.searchInputValue = "";
    this.$store.state.homePageSearchInput = "";
    this.$store.state.homePageSearchLoaded = false;
    this.$store.state.showHomePageSearchInput = true;
    window.removeEventListener("scroll", this.handleScroll);
  },
  watch: {
    activeOptionMenu(newVal){
    },
   
    searchInputValue(newVal) {
      if (newVal == "") this.isSearching = false;
      else if (newVal.length > 0 && !this.isSearching) this.isSearching = true;
    },
    "$store.state.homePageSearchInput"(newVal) {
      this.searchTrainingsInput();
      if (newVal == "") this.isSearching = false;
      else if (newVal.length > 0 && !this.isSearching) this.isSearching = true;
    },
    loaded() {
      this.$store.state.homePageSearchLoaded = this.loaded;
    },
    '$route.query.id':{
      handler(){
        this.loadEditPage();
      }
    }
  },
  methods: {
    startTitleEdit() {
      if(!this.hasPermission('trainings.edit_in_groups') && (this.trainingGroup.created_by != this.$store.state.user_id)) return
      this.editingTitle = true;
      this.$nextTick(()=>{
        let ref = this.$refs.titleInput;
        if(Array.isArray(ref)) ref = ref[0];
        ref.focus();
      })
    },
    closeStats(){
      this.selectedTrainingStats=-1
      this.$store.state.loading.loadingStart();
      setTimeout(() => {
          this.$store.state.loading.loadingDone();
      }, 100);
    },
    showMenuItem(training, type){
      if(type == 'view'){
        if(this.$store.state.system_settings.trainingOptions && this.$store.state.system_settings.trainingOptions.menu && this.$store.state.system_settings.trainingOptions.menu.view != undefined){
          return this.$store.state.system_settings.trainingOptions.menu.view
        }
        return true;
      }
      if(type == 'users'){
        if((this.$store.state.user_role == 'admin' || this.hasPermission('users.assign_trainings')) && (training && training.data ? training.data.trainingType != 'attest' : true)){
          if(this.$store.state.system_settings.trainingOptions && this.$store.state.system_settings.trainingOptions.menu && this.$store.state.system_settings.trainingOptions.menu.users != undefined){
            return this.$store.state.system_settings.trainingOptions.menu.users
          }
          return true;
        }
        else{
          return false
        }
      }
      if(type == 'stats'){
        if(this.$store.state.user_role == 'admin' || this.hasPermission('users.view_stats')){
          if(this.$store.state.system_settings.trainingOptions && this.$store.state.system_settings.trainingOptions.menu && this.$store.state.system_settings.trainingOptions.menu.stats != undefined){
            return this.$store.state.system_settings.trainingOptions.menu.stats
          }
          return true;
        }
        else{
          return false
        }
      }
      if(type == 'delete'){
        if(this.showDeleteButton(training)){
          if(this.$store.state.system_settings.trainingOptions && this.$store.state.system_settings.trainingOptions.menu && this.$store.state.system_settings.trainingOptions.menu.delete != undefined){
            return this.$store.state.system_settings.trainingOptions.menu.delete
          }
          return true;
        }
        else{
          return false
        }
      }
      if(type == 'copy'){
        if(this.showDeleteButton(training)){
          if(this.$store.state.system_settings.trainingOptions && this.$store.state.system_settings.trainingOptions.menu && this.$store.state.system_settings.trainingOptions.menu.delete != undefined){
            return this.$store.state.system_settings.trainingOptions.menu.delete
          }
          return true;
        }
        else{
          return false
        }
      }
      if(type == 'move'){
        if(this.showDeleteButton(training)){
          if(this.$store.state.system_settings.trainingOptions && this.$store.state.system_settings.trainingOptions.menu && this.$store.state.system_settings.trainingOptions.menu.delete != undefined){
            return this.$store.state.system_settings.trainingOptions.menu.delete
          }
          return true;
        }
        else{
          return false
        }
      }
    },
    uploadGif(gif){
        let link = gif;
        if (!link) return;
        let formData = new FormData();
        formData.append("imgURL", link);
        this.isUploadingCover = true;
        axios
        .post(
          `${this.$store.state.api_link}/upload-gif`,
          formData,
          this.$store.getters.axiosConfigMultipart()
        )
        .then((response) => {
          if (response.data.status == "success") {
            this.selectedFolder['data'] = {
              image: response.data.file,
              type: 'gif',
            }
            this.saveGroup();
            this.galleryOpen = false;
            return;

          } else {
            alert("Error while uploading file");
            this.galleryOpen = false;
          }
        })
        .catch(() => {
          alert("Error while uploading file");
            this.galleryOpen = false;
        });

        return;
      
    },
    showMenu(training, type = 'default'){
      if(type == 'dots' && (this.$store.state.user_role == 'admin' || this.hasPermission('users.assign_trainings') || this.hasPermission('trainings.edit') || this.hasPermission('users.view_stats'))){
        if(this.$store.state.system_settings.trainingOptions && this.$store.state.system_settings.trainingOptions.showMenu != undefined){
          return this.$store.state.system_settings.trainingOptions.showMenu;
        }
        return true
      }
      if((this.$store.state.user_role == 'admin' || this.hasPermission('users.assign_trainings') || this.hasPermission('trainings.edit') || this.hasPermission('users.view_stats')) && (this.activeOptionMenu == training.id)){
        if(this.$store.state.system_settings.trainingOptions && this.$store.state.system_settings.trainingOptions.showMenu != undefined){
          return this.$store.state.system_settings.trainingOptions.showMenu;
        }
        return true;
      }
      return false;
    },
    finishTitleEdit() {
      if(!this.hasPermission('trainings.edit_in_groups') && (this.trainingGroup.created_by != this.$store.state.user_id)) return
      
      if( this.editingTitle)
        this.saveGroupInfo();
      this.editingTitle = false;
    },
    showDeleteButton(training) {
      if (this.$store.state.user_role == 'admin') return true;
      let show = false;
      let edit_permission = this.hasPermission('trainings.edit');
      if (edit_permission) {
       
        if (this.hasPermission('trainings.edit_own')) {
          let created_by = training.created_by;
          if (created_by == this.$store.state.user_id) {
            show = true;
          }
        }
        else show = true;
        if (this.$store.state.user_permissions['trainings.edit_in_groups']) {
          let ids = this.$store.state.user_permissions['trainings.edit_in_groups'].items;
          if (ids.includes(this.trainingGroup.id) || this.$store.state.user_permissions['trainings.edit_in_groups'].all_selected) {
            show = true;
          }
          else show = false;
        }
      }
      else {
        show = false;
      }
      return show;
      
    },
    saveGroup(){
      axios.post(
        `${this.$store.state.api_link}/training_group/editInfo/${this.selectedFolder.id}`,
        {
          data: this.selectedFolder['data'],
          keys: ['data'],
        },
        this.$store.getters.axiosConfig()
      )
      .then((response) => {
        this.selectedFolder = null;
      })
      .catch((error) => {
        this.$store.commit("handleError", { error: error });
      });
    },
    saveGroupInfo(){
      axios
        .post(
          `${this.$store.state.api_link}/training_group/editInfo/${this.trainingGroup.id}`,
          {
            name: this.trainingGroup.name,
          },
          this.$store.getters.axiosConfig()
        )
        .then((response) => {
        })
        .catch((error) => {
          this.$store.commit("handleError", { error: error });
        });
    },
    updateGroupTitle(title){
      if(!this.hasPermission('trainings.edit_in_groups') && (this.trainingGroup.created_by != this.$store.state.user_id)) return

      axios
        .post(
          `${this.$store.state.api_link}/training_group/editInfo/${this.trainingGroup.id}`,
          {
            name: title,
          },
          this.$store.getters.axiosConfig()
        )
        .then((response) => {
        })
        .catch((error) => {
          this.$store.commit("handleError", { error: error });
        });
    },
    uploadGroupImg(e){
      let formData = new FormData();
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      let file = files[0];
      formData.append("file", file);

      axios.post(`${this.$store.state.api_link}/upload-file`, formData,this.$store.getters.axiosConfigMultipart()).then((response)=>{
        if(response.data['status'] == 'success'){
          this.selectedFolder['data'] = {
            image: response.data.file,
          }
          this.galleryOpen = false;

          this.saveGroup();
        }
      })
    },
    removeGroupImg(){
      axios.post(
                `${this.$store.state.api_link}/training_group/editInfo/${this.selectedFolder.id}`,
                {
                  data: this.selectedFolder['data'],
                  keys: ['data'],
                },
                this.$store.getters.axiosConfig()
              )
              .then((response) => {
                this.trainingGroupsClone = _.cloneDeep(this.trainingGroups);
              })
              .catch((error) => {
                this.$store.commit("handleError", { error: error });
              });
    },
    loadEditPage(){
       this.$store.state.loading.loadingStart();
      this.loaded = false;
      if(this.$route.query.id){
        this.$store.state.currentGroupOpen = this.$route.query.id 
      }
      setTimeout(() => {
        this.loadTrainings();
      }, 10);
      if(this.$store.state.currentTraining != -1){
        this.$store.state.currentTraining = -1;
      }
    },
    closeMenus() {
      setTimeout(() => {
        if (this.activeOptionMenu != -50) {
          this.activeOptionMenu = -50;
        }
      }, 200);
    },
    goBack() {
      if(this.trainingGroup.path && this.trainingGroup.path.length > 1){
        let previous_group = this.trainingGroup.path[this.trainingGroup.path.length - 2].id;
        this.$router.push("/edit-group?id=" + previous_group);
        // if (window.history.length > 1) {
        //   this.$router.back();
        // } else {
        // }
      }
      else{
        this.$router.push("/edit");
      }
    },
    goToGroup(id){
      if(id == 0){
        this.$router.push("/edit");
      }
      else{
        this.$router.push("/edit-group?id=" + id);
      }
    },
    handleScroll() {
      if (this.$refs["headerbuttons"] != undefined) {
        if (this.$refs["headerbuttons"].getBoundingClientRect().top >= 100) {
          this.isHeaderInView = true;
        } else {
          this.isHeaderInView = false;
        }
      }
    },
    loadTrainings() {
      let id = this.$store.state.currentGroupOpen;
      axios
        .get(
          `${this.$store.state.api_link}/training_group/training_groups_edit/${id}`,
          this.$store.getters.axiosConfig()
        )
        .then((response) => {
          let temp = response.data;
          if (temp[0] == undefined) {
            this.$store.state.loading.loadingDone();
            return;
          } else if (temp[0] != undefined) {
            temp.forEach((trainingGroup) => {
              trainingGroup["editingTitle"] = false;
              let training_groups = trainingGroup.training_groups
              if(training_groups){
                training_groups.forEach((group) => {
                  if (
                    group.color_slider_pos != null &&
                    group.color_slider_pos != undefined
                  ) {
                      this.changeGroupHue(
                        group,
                        group.color_slider_pos
                      );
                    }
                })
              }
              trainingGroup.trainings.forEach((training) => {
                training.data = JSON.parse(training.data);
              });
              trainingGroup.trainings.sort((a, b) => {
                if (a.weight < b.weight) return -1;
                else if (a.weight > b.weight) return 1;
                else return 0;
              });
              this.addingTraining = false;
              this.addingNewGroup = false;
              setTimeout(() => {
                this.loaded = true;
              }, 20);
    
            });
            this.trainingGroup = temp[0];
            this.trainings = temp[0].trainings;
            this.trainingsClone = _.cloneDeep(temp[0].trainings);
            VueScrollTo.scrollTo(`body`, 100);
            this.$store.state.loading.loadingDone();
          }
        })
        .catch((error) => {
          console.log(error)
          this.$store.commit("handleError", { error: error });
        });
    },
    toggleDrag(folder, event) {
      this.dragItems[folder.id] = event;
      let checker = arr => Object.values(arr).every(v => v === false);
      if(checker(this.dragItems))
        this.dragDisabled = false;
      else{
        this.dragDisabled = true;
      }
    },
    changeGroupHue(folder, optionalColor) {
      if (optionalColor != undefined) {
        this.colorHue = optionalColor;
      }
      let colorGroup = Math.floor(
        this.colorHue %
          this.colorPalettes[this.$store.state.system_settings.color_palette]
            .length
      );
      this.color1 =
        this.colorPalettes[this.$store.state.system_settings.color_palette][
          colorGroup
        ];
      if (
        this.colorPalettes[this.$store.state.system_settings.color_palette][
          colorGroup + 1
        ] == undefined
      ) {
        this.color2 ==
          this.colorPalettes[this.$store.state.system_settings.color_palette][
            this.colorPalettes[this.$store.state.system_settings.color_palette]
              .length - 1
          ];
      } else {
        this.color2 =
          this.colorPalettes[this.$store.state.system_settings.color_palette][
            colorGroup + 1
          ];
      }
      // this.colorHue /= 100;
      let color1Values = this.color1
        .replace("rgba(", "")
        .replace(")", "")
        .split(",");
      let color2Values = this.color2
        .replace("rgba(", "")
        .replace(")", "")
        .split(",");
      let copiedColor = this.colorHue;
      for (let i = 1; i <= copiedColor; ) {
        copiedColor -= 1;
      }
      let midwayValues = color1Values.map(
        (val, index) =>
          (1 - copiedColor) * parseInt(val) +
          copiedColor * parseInt(color2Values[index])
      );
      midwayValues[midwayValues.length - 1] = 1;
      let color = `rgba(${midwayValues
        .map((val) => Math.floor(val))
        .join(",")})`;
      if(!folder.color_hue){
        folder.color_hue = color;
        
      }
      if(folder.color_hue && !folder.color_hue.startsWith('#'))
        folder.color_hue = color;
    },
    loadTraining(id) {
      return axios
          .get(
            `${this.$store.state.api_link}/training/info/${id}?edit=true`,
            this.$store.getters.axiosConfig()
          );
    },
    openTraining(id, training) {
      this.$store.state.loading.loadingStart();

      if (training && training.data && ['scorm','singleDoc'].includes(training.data.trainingType)) {
          this.$store.state.currentTraining = id;
         this.loadTraining(id).then((response) => {
          let data = JSON.parse(response.data.data);
          let index = [0, 0];
           let item = null
           if (training.data.trainingType == 'scorm') {

             index[0] = data.content.findIndex(el => {
               index[1] = el.items.findIndex(item => item.type == 'scorm')
               if (index[1] != -1) {
                 item = el.items[index[1]];
               }
               return index[1] != -1
             })
             if (item) {
               this.overlay.data.item = item;
               this.overlay.data.training = this.$store.state.currentTraining;
             }
           }
           else if (training.data.trainingType == 'singleDoc') {
            item = data.content[0].items[0];
            if (item) {
              this.overlay.data.item = item;
              this.overlay.data.training = data;
            }
           }

          this.overlay.open = true;

          this.$store.state.loading.loadingDone();
        });
      }
      else if(training && training.data && training.data.type == 'new_player'){
        this.$store.state.loading.loadingDone();
        this.$router.push("/edit-training-new/" + training.data.id+'?mode=view');
        return;
      }
      else {

        this.$store.state.previewMode = true;
        this.$store.state.currentTraining = id;
        this.$store.state.currentTrainingData = training;
        this.$store.state.previewTopic = -1;
        this.$router.push("/training?id=" + id);
      }
    },
    closeDeleteModal() {
      this.deleteModalOpened = false;
      this.deletingStatus = "";
    },
    editTraining(id, query = null, created_by = null) {
      if(this.$store.state.user_role == 'admin' || this.hasPermission('trainings.edit')){
        this.$store.state.loading.loadingStart();
        this.$store.state.currentTraining = id;
        this.$store.state.previewTopic = -1;
        if (this.$store.state.user_role == 'admin') {
           let training = this.trainings.find((t) => t.id == id);
           if(training && training.data && training.data.type == 'new_player'){
              this.$store.state.loading.loadingDone();
              this.$router.push("/edit-training-new/" + training.data.id);
              return;
           }
           if(query){
              this.$router.push("/edit-training?id=" + id+query);
            }
            else{
              this.$router.push("/edit-training?id=" + id);
          }
          return;
        }
        if (this.hasPermission('trainings.edit_own')) {
          let training = this.trainings.findIndex((t) => t.id == id);

          if (training != -1) {
            if (created_by != this.$store.state.user_id) {
              this.$router.push("/training?id=" + id);
            }
            else {
              if(query){
                this.$router.push("/edit-training?id=" + id+query);
              }
              else{
                this.$router.push("/edit-training?id=" + id);
              }
            }
          }
          else if(created_by && (created_by == this.$store.state.user_id)){
            this.$router.push("/edit-training?id=" + id);
          }
        }
        else if (this.$store.state.user_permissions['trainings.edit_in_groups']) {
          let ids = this.$store.state.user_permissions['trainings.edit_in_groups'].items;
          if (ids.includes(this.trainingGroup.id) || this.$store.state.user_permissions['trainings.edit_in_groups'].all_selected) {
            if(query){
              this.$router.push("/edit-training?id=" + id+query);
            }
            else{
              this.$router.push("/edit-training?id=" + id);
            }
          }
          else {
            this.$router.push("/training?id=" + id);
          }
        }
        else {
          if(query){
            this.$router.push("/edit-training?id=" + id+query);
          }
          else{
            this.$router.push("/edit-training?id=" + id);
          }
          
        }
      }
      else {
        this.$router.push("/training?id=" + id);
      }
    },
    trainingStats(training, id, rentedStatus) {
      if(rentedStatus == 1){
        this.$store.state.currentTrainingRented = true;
      }else{
        this.$store.state.currentTrainingRented = false;
      }
      this.$store.state.loading.loadingStart();
      this.$store.state.currentTraining = id;
      this.selectedTrainingStats = id
      this.selectedTrainingItem = training;
      // this.$router.push("/training-stats");
    },
    addNewTraining(group, type='training') {
      this.addingTraining = true;
      axios
        .post(
          `${this.$store.state.api_link}/training/add`,
          { training_group: group, type },
          this.$store.getters.axiosConfig()
        )
        .then((response) => {
          this.loadTrainings();
          let query = '&editTitle=1'
          this.$nextTick(() => {
            if(response.data.created_by)
              this.editTraining(response.data.training, query, response.data.created_by);
            else this.editTraining(response.data.training, query);
          })
        })
        .catch((error) => {
          this.$store.commit("handleError", { error: error });
        });
    },
    addNewTrainingV2(group, type) {
      if(type != 'physical'){
        if(type == 'training_group'){
          this.addNewTrainingGroup(this.$store.state.currentGroupOpen);
        }
        else{
          this.addNewTraining(group, type);
        }
      }
      else{
        axios
          .post(
            `${this.$store.state.api_link}/trainings-new`,
            { lms_key: this.$store.state.currentLMS, content_type: type, training_group: group, type: 'physical' },
            this.$store.getters.axiosConfig()
          )
          .then((response) => {
            let training = response.data.main_platform_training;
            training.data = JSON.parse(training.data);
            this.trainings.push(training);
            this.$nextTick(() => {
              if(response.data.created_by)
                this.editTraining(response.data.main_platform_training.id, null, response.data.created_by);
              else this.editTraining(response.data.main_platform_training.id, null);
            })
            // this.$nextTick(() => {
            //   this.editTraining(response.data.training, query);
            // })
          })
          .catch((error) => {
            this.$store.commit("handleError", { error: error });
          });
      }
    },
    addNewTrainingGroup(group){
      if (this.addingTrainingGroup) {
        return;
      }
      this.addingTrainingGroup = true;
      this.addingNewGroup = true;
      axios
        .post(
          `${this.$store.state.api_link}/training_group/add`,
          { 
            name: this.toLocal("training.new_training_group"),
            training_group_id: group
          },
          this.$store.getters.axiosConfig()
        )
        .then((response) => {
          let new_training_group = response.data.training_group;
          this.trainingGroups.unshift(new_training_group);
          this.addingNewGroup = false;
          axios
            .post(
              `${this.$store.state.api_link}/training_group/set-order`,
              { training_groups: this.trainingGroups.map((el) => el.id) },
              this.$store.getters.axiosConfig()
            )
            .then((response) => {
              this.$store.state.currentGroupOpen = new_training_group.id;
              this.$router.push("/edit-group?id=" + new_training_group.id + "&editTitle=1");
              this.addingTrainingGroup = false;
            })
            .catch((err) => {
              console.log(err)
            });
        })
        .catch((error) => {
          this.$store.commit("handleError", { error: error });
          this.addingTrainingGroup = false;
        });
    },
    deleteTraining(id){
      this.deletingTrainingID = id;
      this.deletingTraining = true;
    },
    copyTraining(id){
      this.copyTrainingModalOpen = true;
      this.copyTrainingID = id;
    },
    moveTraining(id){
      this.moveTrainingModalOpen = true;
      this.moveTrainingID = id;
    },
    deleteTrainingRequest() {
      // if (!confirm(this.$store.getters.__("training_edit.delete_confirm")))
      //   return;

      this.addingTraining = true;
      axios
        .post(
          `${this.$store.state.api_link}/training/delete`,
          { id: this.deletingTrainingID },
          this.$store.getters.axiosConfig()
        )
        .then((response) => {
          this.deletingTraining = false;
          this.deletingTrainingID = -1;
          this.loadTrainings();
        })
        .catch((error) => {
          this.deletingTraining = false;
          this.deletingTrainingID = -1;
          this.$store.commit("handleError", { error: error });
        });
    },
    openGroupSide(training) {
      this.selectedTraining = training;
      this.$store.commit("openSide", {
        side: "training-groups-side",
        sideInfo: { id: training.id },
      });
    },
    onTrainingListChange(group) {
      setTimeout(() => {
        let updatedWeightSearch = [];
        let updatedWeight = [];
        let weight = 1;
        group.trainings.forEach((training, index) => {
          updatedWeightSearch.push({ [training.id]: index + 1 });
        });
        group.trainings.forEach((training, index) => {
          updatedWeight.push({ [training.id]: index + 1 });
        });
        axios
          .post(
            `${this.$store.state.api_link}/training/set-training-weight`,
            { trainings: JSON.stringify(updatedWeightSearch) },
            this.$store.getters.axiosConfig()
          )
          .then((response) => {
            // this.loadTrainings();
          })
          .catch((error) => {
            this.$store.commit("handleError", { error: error });
          });
      }, 10);
    },
    confirmedGroupDelete() {
      axios
        .post(
          `${this.$store.state.api_link}/training_group/delete`,
          { id: this.deletingStatus },
          this.$store.getters.axiosConfig()
        )
        .then((response) => {
            this.trainingGroup.training_groups = this.trainingGroup.training_groups.filter(
              (obj) => obj.id != this.deletingStatus
            );
            this.trainingGroupsClone = this.trainingGroup.training_groups;
            this.deletingStatus = "";
            this.multiChoiceInfo.disableTime = false;
            this.deleteModalOpened = false;
        })
        .catch((error) => {
          this.$store.commit("handleError", { error: error });
          this.addingNewGroup = false;
        });
    },
    removeMovedTraining(){
      if(this.moveTrainingID == 'all'){
        this.confirmedGroupDelete();
        this.multiChoiceOpened = false;
      }
      else{
        let id = this.moveTrainingID;
        let index = this.trainingGroup.trainings.findIndex((training) => training.id == id);
        if (index != -1) {
          this.trainingGroup.trainings.splice(index, 1);
        }
        index = this.trainings.findIndex((training) => training.id == id);
        if (index != -1) {
          this.trainings.splice(index, 1);
        }
      }
    },
    searchTrainingsInput(event) {
      this.searchTrainings(event, this);
    },
    searchTrainings: _.debounce((event, self) => {
      // let text = self.$store.state.homePageSearchInput;
      if (self.searchTerm != "") {
        self.trainingGroup.trainings = self.trainingsClone.filter(
          (training) =>
            training.data &&
            training.data.title &&
            training.data.title != null &&
            training.data.title
              .toLowerCase()
              .includes(self.searchTerm.toLowerCase())
        );
      } else {
        self.trainingGroup.trainings = self.trainingsClone;
      }
    }, 10),

    setGroupOrder(groups, id, up) {
      var canOrder = false;
      groups = groups.filter(function (element) {
        return element !== undefined;
      });
      if (up) {
        if (id != 0) {
          this.swapElement(groups, id, id - 1);
          id = id - 1;
          canOrder = true;
        }
      } else {
        if (groups.length - 1 != id) {
          this.swapElement(groups, id, id + 1);
          id = id + 1;
          canOrder = true;
        }
      }
      if (canOrder) {
        axios
          .post(
            `${this.$store.state.api_link}/training_group/set-order`,
            { training_groups: [this.trainingGroup] },
            this.$store.getters.axiosConfig()
          )
          .then((response) => {})
          .catch(() => {});
      }
    },
    swapElement(array, indexA, indexB) {
      var tmp = array[indexA];
      array[indexA] = array[indexB];
      array[indexB] = tmp;
    },
    searchVisibilityChanged(e) {
      if (this.$store.state.homePageSearchLoaded)
        this.$store.state.showHomePageSearchInput = e;
    },
    getTrainingTime(time){
      let minutes = time;
      let hours = Math.floor(minutes / 60);
      minutes = minutes % 60;
      return  hours > 0 ? hours + ' val. '+minutes+' min.' : minutes+' min.'
    },
    showCreateBtn() {
      if (this.$store.state.user_role == 'admin') return true;
      if (this.hasPermission('trainings.create')) {
        if (this.$store.state.user_permissions['trainings.edit_in_groups']) {
          let ids = this.$store.state.user_permissions['trainings.edit_in_groups'].items;
          if (ids.includes(this.trainingGroup.id) || this.$store.state.user_permissions['trainings.edit_in_groups'].all_selected) {
            return true;
          }
          else return false;
        }
        else {
          return true;
        }
      }
      return false
    },
    showGroupCreateBtn(){
      if(this.trainingGroup.path && this.trainingGroup.path.length > 4) return false;
      if (this.$store.state.user_role == 'admin') return true;
      if (this.hasPermission('trainings.create') && this.hasPermission('trainings.training_group_create')) {
        if (this.$store.state.user_permissions['trainings.edit_in_groups'] && this.$store.state.user_permissions['trainings.training_group_create']) {
          let ids = this.$store.state.user_permissions['trainings.edit_in_groups'].items;
          if (ids.includes(this.trainingGroup.id) || this.$store.state.user_permissions['trainings.edit_in_groups'].all_selected) {
            return true;
          }
          else return false;
        }
        else {
          return true;
        }
      }
      return false
    },
    openTrainingGroupSide(folder){
      this.selectedFolder = folder;
      this.$store.commit("openSide", {
        side: "training-groups-side",
        sideInfo: { id: folder.id },
      });
    },
    openGroup(id) {
      this.$store.state.currentGroupOpen = id;
      if (id == -1) {
        this.$router.push("/bought-trainings");
      } else {
        this.$router.push("/edit-group?id=" + id);
      }
    },
    deleteGroup(group) {
      if (group.trainings.length == 0 || group.trainings == 0) {
        this.deletingStatus = group.id;
        this.deleteModalOpened = true;
      } else {
        this.multiChoiceOpened = true;
        this.multiChoiceInfo = {
          type: "multiChoice",
          text: "modal.group_with_trainings",
          undertext: "modal.choose_what_to_do",
          multiChoiceYes: "modal.transfer_to_another",
          multiChoiceNo: "modal.delete_forever",
          underBtnText: "",
        };
        this.deletingStatus = group.id;
      }
    },
   
    choiceOne() {
      this.moveTrainingModalOpen = true;
      this.moveTrainingID = 'all'
    },
    choiceTwo() {
      this.multiChoiceInfo.type = "confirmation";
      this.multiChoiceInfo.confirmBtnText = "delete_modal.yes_delete";
      this.multiChoiceInfo.undertext = "modal.trainings_will_not_be_saved";
    },
    deleteGroupWithTrainings() {
      axios
        .post(
          `${this.$store.state.api_link}/training_group/delete_with_trainings`,
          { id: this.deletingStatus },
          this.$store.getters.axiosConfig()
        )
        .then((response) => {
          if (response.status == 200) {
            this.trainingGroup.training_groups = this.trainingGroup.training_groups.filter(
              (obj) => obj.id != this.deletingStatus
            );
            this.trainingGroupsClone = this.trainingGroup.training_groups;
            this.deletingStatus = "";
            this.multiChoiceInfo.disableTime = false;
            this.multiChoiceOpened = false;
          }
        })
        .catch((error) => {
          this.$store.commit("handleError", { error: error });
        });
    },
    uploadFolderImg(folder){
      this.galleryOpen = true;
      this.selectedFolder = folder;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/views/_homeEditViewScoped.scss";
.stats-open{
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}
.home-section{
  &.home-table-view{
    overflow-y: hidden;
    width: initial;
    padding-left: 2rem;
    .button-container{
      width: 100%;
      padding-right: 2rem;
    }
  }
}
.languages{
  display: inline-flex;
  margin-left: 5px;
  &.parent{
    padding: 5px;
    border-radius: 50%;
    background-color: white;
  }
  svg{
    height: 20px;
    width: 20px;
  }
}
.tag-container {
  position: absolute;
  top: 25px;
  left: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  max-width: 94%;
  gap: 8px;
  span {
    position: relative;
    padding: 8px 12px 7px 16px;
    background: var(--secondary-color);
    color: var(--primary-color);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.16);
    border-radius: 0px 20px 20px 0px;
    top: initial;
    line-height: 24px;
    font-size: 16px;
    width: fit-content;
    &.white {
      display: flex;
      align-items: center;
      svg {
        margin-left: 11px;
      }
      background: white;
    }
  }
  .physical-tag{
    overflow: hidden;
    white-space: nowrap;
    max-width: 100%;
    text-overflow: ellipsis;
  }
  .selling-tag{
    background: var(--third-color);
  }
  .attest-tag{
    display: flex;
    align-items: center;
    gap: 6px;
    color: white;
    background: #4D4D4D;
  }
}
</style>
<style lang="scss">
.tooltip-container{
  &.icon-tooltip{
    border-color: #333;
  }
}
</style>